export default __webpack_public_path__ + "static/media/po-photo.4edc2197.jpeg";